import { lazy } from 'react';

const Kyc = lazy(() => import(/* webpackChunkName: "kyc" */ './Kyc'));

export default Kyc;
